import hpLogoUrl from "../../assets/hindustan-power-logo.png";

/** Source asset is 200×42 — wide horizontal wordmark, not a square icon. */
const LOGO_WIDTH = 200;
const LOGO_HEIGHT = 42;

export interface HpWordmarkProps {
  /** Tailwind width class, e.g. w-[11.5rem] or w-28 */
  size?: "sidebar" | "sidebar-md" | "sidebar-mini" | "login" | "compact";
  className?: string;
}

const SIZE_CLASS: Record<NonNullable<HpWordmarkProps["size"]>, string> = {
  sidebar: "w-[11.5rem]",
  "sidebar-md": "w-[9.5rem]",
  "sidebar-mini": "w-[5.25rem]",
  login: "w-[14rem]",
  compact: "w-[7.5rem]",
};

/** Hindustan Power corporate wordmark — always preserve aspect ratio, never crop into a square. */
export function HpWordmark({ size = "sidebar", className = "" }: HpWordmarkProps) {
  return (
    <img
      src={hpLogoUrl}
      alt="Hindustan Power"
      width={LOGO_WIDTH}
      height={LOGO_HEIGHT}
      decoding="async"
      className={["block h-auto max-w-full flex-none object-contain object-left", SIZE_CLASS[size], className].join(
        " ",
      )}
    />
  );
}
